import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14V2zm1 2a1 1 0 0 0 0 2h11V4zm8.901 13.606-.2-.8A3.705 3.705 0 0 0 12.108 14h-.214a3.705 3.705 0 0 0-3.595 2.807l-.2.799c-.06.238.03.49.227.638a6.124 6.124 0 0 0 7.35 0 .61.61 0 0 0 .226-.639M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      clipRule: "evenodd"
    }
  )
);
var SvgContactsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactsFilled_default = SvgContactsFilled;

export { ContactsFilled_default as default };
